import React from 'react';
import Button from '../ui/Button';

const userLang = navigator.language || navigator.userLanguage;

/**
 * Component for displaying merchant verification status and controls
 */
const MerchantVerification = ({
  accountStatus,
  statusError,
  isStatusError,
  isVerifying,
  verificationStep,
  onVerify,
  getVerificationButtonText
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">
        {userLang === 'zh-CN' ? '商家认证' : 'Merchant Verification'}
      </h3>
      
      {isStatusError || accountStatus?.error ? (
        <div>
          <div className="flex items-center text-red-600 mb-4">
            <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <span className="font-medium">
              {userLang === 'zh-CN' ? '验证状态错误' : 'Status Error'}
            </span>
          </div>
          <p className="text-sm text-gray-600 mb-4">
            {accountStatus?.error || statusError?.message || 'Unable to check verification status'}
          </p>
          <Button
            onClick={onVerify}
            disabled={isVerifying || verificationStep !== 'idle'}
            isLoading={verificationStep !== 'idle'}
            variant="teal"
            size="md"
          >
            {getVerificationButtonText()}
          </Button>
        </div>
      ) : accountStatus?.status?.chargesEnabled ? (
        <div className="flex items-center text-green-600">
          <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
          <span className="font-medium">
            {userLang === 'zh-CN' ? '已认证' : 'Verified'}
          </span>
        </div>
      ) : accountStatus?.status?.detailsSubmitted ? (
        <div>
          <div className="flex items-center text-yellow-600 mb-4">
            <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <span className="font-medium">
              {userLang === 'zh-CN' ? '审核中' : 'Under Review'}
            </span>
          </div>
          <Button
            onClick={onVerify}
            disabled={isVerifying || verificationStep !== 'idle'}
            isLoading={verificationStep !== 'idle'}
            variant="teal"
            fullWidth
            size="md"
          >
            {getVerificationButtonText()}
          </Button>
        </div>
      ) : (
        <div>
          <div className="flex items-center text-yellow-600 mb-4">
            <svg className="h-5 w-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <span className="font-medium">
              {userLang === 'zh-CN' ? '未认证' : 'Not Verified'}
            </span>
          </div>
          <Button
            onClick={onVerify}
            disabled={isVerifying || verificationStep !== 'idle'}
            isLoading={verificationStep !== 'idle'}
            variant="teal"
            size="md"
          >
            {getVerificationButtonText()}
          </Button>
        </div>
      )}
    </div>
  );
};

export default MerchantVerification; 